import React, { useState, useEffect } from "react";
import { Box, Grid, IconButton, Typography, Avatar } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import { headers, convertGMTToIST } from "../utils/utils";
import { red, blue, green } from "@mui/material/colors";
import AuditNotificationComponent from "../utils/AuditNotificationComponent"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const AuditDisplay = ({ ticket, memberList, tagList }) => {
  const [auditLogs, setAuditLogs] = useState([]); // State to track the comment history
  const [showHistory, setShowHistory] = useState(false);
  const toggleHistory = () => setShowHistory(prev => !prev);
  // Fetch comment history
  const fetchAuditLogs = async () => {
    console.log("ticket id in audit", ticket.id);
    if (!ticket.id) {
      setAuditLogs([]);
      return;
    }

    try {
      const response = await fetch(
        process.env.REACT_APP_AUDITLOG +
        `/api/audit/logs?entityType=Ticket&entityId=${ticket.id}`,
        {
          method: "GET",
          headers: headers(),
        },
      );

      if (response.ok) {
        const data = await response.json();

        const sortedComments = data.sort((a, b) => b.id - a.id);

        setAuditLogs(sortedComments);
        console.log("data a", sortedComments);
      } else {
        console.error("Failed to fetch comments");
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const formatDate = (value) => {
    const timestamp = Number(value);
    const utcDate = new Date(value + 'Z');


    return utcDate.toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });


  };


  useEffect(() => {
    if(showHistory)
    fetchAuditLogs();

  }, [showHistory]);


  return (
    <Grid item xs={12} sm={7.8} sx={{ ml: 2 }}>
      <div>
        <AuditNotificationComponent ticketId={ticket.id} fetchAuditLogs={fetchAuditLogs} />
        {/* Header */}
        <Box
          sx={{ display: "flex", mt: 2, cursor: "pointer" }}
          onClick={toggleHistory}
        >
          <CommentIcon />
          <Typography
            component="div"
            variant="body2"
            color="text.secondary"
            sx={{ ml: 1 }}
          >
            <strong>History</strong>
            <IconButton size="small" sx={{ ml: 1 }}>
              {showHistory ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Typography>
        </Box>


        {/* Comment History */}
        {showHistory && (
          <Box sx={{ mt: 4 }}>
            {auditLogs.length > 0 ? (
              auditLogs
                .filter(
                  (aud) =>
                    aud.columnName !== "updatedDate" &&
                    aud.columnName !== "updatedBy" &&
                    aud.columnName !== "totalWorkSeconds" &&
                    aud.columnName !== "ticketItems",

                )
                .map((audit) => {
                  const member = memberList && memberList.find(
                    (member) => member.id === audit.userId,
                  );
                  if (!member)
                    return null;

                  return (
                    <Grid container spacing={1} key={audit.id}>
                      <Grid item xs={0.4}>
                        <Avatar
                          sx={{
                            marginRight: "8px",
                            background: red[500],
                            width: 30,
                            height: 30,
                            fontSize: "0.8rem",
                          }}
                        >
                          {member && member.fullName[0].toUpperCase()}
                        </Avatar>
                      </Grid>

                      <Grid item xs={11}>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            component="div"
                            variant="body2"
                            color="text.secondary"
                            sx={{ ml: 1 }}
                          >
                            {audit?.action === "CREATE TICKET" && member ? (
                              <>
                                <Typography
                                  variant="caption"
                                  component="span"
                                  gutterBottom
                                  sx={{ color: blue[900], fontSize: "0.9rem" }}
                                >
                                  <b>{member && member.fullName} </b>
                                </Typography>
                                is created Card.
                                <Typography
                                  variant="body"
                                  component="div"
                                  color="text.secondary"
                                  sx={{ color: blue[10], fontSize: "0.7rem" }}
                                >
                                  {audit.createdBy} •{" "}
                                  <b>
                                    {new Date(audit.timestamp + 'Z').toLocaleString('en-IN', {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric',
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      second: '2-digit',
                                      hour12: true,
                                      timeZone: 'Asia/Kolkata'
                                    })}
                                  </b>

                                </Typography>

                              </>
                            ) : (
                              <>
                                {(() => {
                                  let content;
                                  switch (audit.columnName) {
                                    case "memberIds":
                                      let members = [];

                                      let oldValue = audit.oldValue
                                        .slice(1, -1) // Removes the first and last characters (assuming they are quotes or brackets)
                                        .split(",") // Splits the string by commas
                                        .map((item) => item.trim()) // Trims any leading/trailing whitespace
                                        .filter((item) => item !== "");
                                      let newValue = audit.newValue
                                        .slice(1, -1) // Removes the first and last characters (assuming they are quotes or brackets)
                                        .split(",") // Splits the string by commas
                                        .map((item) => item.trim()) // Trims any leading/trailing whitespace
                                        .filter((item) => item !== "");

                                      let displayType = "remove";
                                      if (oldValue.length < newValue.length) {
                                        displayType = "add";
                                      }

                                      if (displayType === "remove") {
                                        let oldValueTemp = oldValue;
                                        oldValue = newValue;
                                        newValue = oldValueTemp;
                                      }

                                      const updatedValue =
                                        oldValue.length === 0
                                          ? newValue
                                          : newValue.filter(
                                            (item) => !oldValue.includes(item),
                                          );

                                      updatedValue.map((mId) => {
                                        if (mId) {
                                          const foundMember = memberList && memberList.find(
                                            (member) =>
                                              member.id.toString() ===
                                              mId.toString(),
                                          );
                                          if (foundMember)
                                            members.push(foundMember.fullName);
                                        }
                                      });

                                      content = (
                                        <>
                                          <Typography
                                            variant="caption"
                                            component="span"
                                            gutterBottom
                                            sx={{
                                              color: blue[900],
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            <b>{member && member.fullName}</b>
                                          </Typography>{" "}
                                          {displayType === "add" ? (
                                            <>
                                              <Typography
                                                variant="caption"
                                                component="span"
                                                gutterBottom
                                                sx={{
                                                  color: green[500],
                                                  fontSize: "0.9rem",
                                                }}
                                              >
                                                <b>{members} </b>
                                              </Typography>
                                              joined this card
                                            </>
                                          ) : (
                                            <>
                                              <Typography
                                                variant="caption"
                                                component="span"
                                                gutterBottom
                                                sx={{
                                                  color: red[500],
                                                  fontSize: "0.9rem",
                                                }}
                                              >
                                                <b>{members} </b>
                                              </Typography>
                                              left this card
                                            </>
                                          )}
                                        </>
                                      );
                                      break;

                                    case "status":
                                      content = (
                                        <>
                                          <Typography
                                            variant="caption"
                                            component="span"
                                            gutterBottom
                                            sx={{
                                              color: blue[900],
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            <b>{member && member.fullName} </b>
                                          </Typography>

                                          <Typography
                                            variant="caption"
                                            component="span"
                                          >
                                            moved to
                                          </Typography>
                                          <Typography
                                            variant="caption"
                                            component="span"
                                            sx={{
                                              color: blue[900],
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            {" " + audit.newValue}
                                          </Typography>
                                        </>
                                      );

                                      break;

                                    case "tags":
                                      let tags = [];

                                      let oldValue1 = audit.oldValue
                                        .slice(1, -1) // Removes the first and last characters (assuming they are quotes or brackets)
                                        .split(",") // Splits the string by commas
                                        .map((item) => item.trim()) // Trims any leading/trailing whitespace
                                        .filter((item) => item !== "");
                                      let newValue1 = audit.newValue
                                        .slice(1, -1) // Removes the first and last characters (assuming they are quotes or brackets)
                                        .split(",") // Splits the string by commas
                                        .map((item) => item.trim()) // Trims any leading/trailing whitespace
                                        .filter((item) => item !== "");

                                      let displayType1 = "remove";
                                      if (oldValue1.length < newValue1.length) {
                                        displayType1 = "add";
                                      }

                                      if (displayType1 === "remove") {
                                        let oldValueTemp = oldValue1;
                                        oldValue1 = newValue1;
                                        newValue1 = oldValueTemp;
                                      }

                                      const updatedValue1 =
                                        oldValue1.length === 0
                                          ? newValue1
                                          : newValue1.filter(
                                            (item) => !oldValue1.includes(item),
                                          );

                                      updatedValue1.map((selectedTag) => {
                                        if (selectedTag) {
                                          try {
                                            const foundTag = tagList.find(
                                              (tag) =>
                                                tag.id.toString() ===
                                                selectedTag.toString(),
                                            ).value;
                                            if (foundTag) tags.push(foundTag);
                                          } catch (e) {

                                          }
                                        }
                                      });
                                      content = (
                                        <>
                                          <Typography
                                            variant="caption"
                                            component="span"
                                            gutterBottom
                                            sx={{
                                              color: blue[900],
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            <b>{member && member.fullName}</b>
                                          </Typography>{" "}
                                          {displayType1 === "add" ? (
                                            <>
                                              <Typography
                                                variant="caption"
                                                component="span"
                                                gutterBottom
                                                sx={{
                                                  color: green[500],
                                                  fontSize: "0.9rem",
                                                }}
                                              >
                                                <b>{tags} </b>
                                              </Typography>
                                              added
                                            </>
                                          ) : (
                                            <>
                                              <Typography
                                                variant="caption"
                                                component="span"
                                                gutterBottom
                                                sx={{
                                                  color: red[500],
                                                  fontSize: "0.9rem",
                                                }}
                                              >
                                                <b>{tags} </b>
                                              </Typography>
                                              removed
                                            </>
                                          )}
                                        </>
                                      );
                                      break;

                                    default:
                                      content = (
                                        <>
                                          <Typography
                                            variant="caption"
                                            component="span"
                                            gutterBottom
                                            sx={{
                                              color: blue[900],
                                              fontSize: "0.9rem",
                                            }}
                                          >
                                            <b>{member && member.fullName} </b>
                                          </Typography>
                                          <b>{audit.columnName}</b> value changed to {audit.columnName === "targetDate" ? formatDate(audit.newValue) : audit.newValue}
                                        </>
                                      );
                                      break;
                                  }
                                  return (
                                    <div>
                                      {content ? (
                                        <>
                                          {content}
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                              color: red[10],
                                              fontSize: "0.7rem",
                                            }}
                                          >
                                            {audit.createdBy} •{" "}
                                            <b>
                                              {formatDate(audit.timestamp)}
                                            </b>


                                          </Typography>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  );
                                })()}
                              </>
                            )}
                          </Typography>
                        </Box>

                        <br />
                      </Grid>
                    </Grid>
                  );
                })
            ) : (
              <Typography variant="body2" color="text.secondary"></Typography>
            )}
          </Box>
        )}
      </div>
    </Grid>
  );
};

export default AuditDisplay;
